import { render, staticRenderFns } from "./CategoriesFilter.vue?vue&type=template&id=6aaa044c&scoped=true&"
import script from "./CategoriesFilter.vue?vue&type=script&lang=js&"
export * from "./CategoriesFilter.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesFilter.vue?vue&type=style&index=0&id=6aaa044c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa044c",
  null
  
)

export default component.exports